import React from 'react';

import Layout from 'sections/Layout';
import Hero from 'sections/WebinarOnDemand/Hero';
import Video from 'sections/WebinarOnDemand/Video';
import Content from 'sections/WebinarOnDemand/Content';

const WebinarOnDemandPostPage = ({ webinarOnDemand, ...props }) => {
  const seo = webinarOnDemand?.seo;
  const lang = webinarOnDemand?.language?.slug;
  const hero = webinarOnDemand?.webinarOnDemand?.webinarOnDemandHero;
  const video = webinarOnDemand?.webinarOnDemand?.webinarOnDemandVideo;
  const form = webinarOnDemand?.webinarOnDemand?.webinarOnDemandFormData;
  const content = webinarOnDemand?.webinarOnDemand?.webinarOnDemandContent;
  const cta = webinarOnDemand?.webinarOnDemand?.webinarOnDemandCtaBlock;

  return (
    <Layout
      seo={seo}
      headerDarkColor={true}
      headerWhiteBg={true}
      requestButtonBlue={true}
      // ogImage={sourceUrl}
    >
      {(commonData) => (
        <>
          <Hero data={hero} />
          <Video data={video} form={form} lang={lang} />

          <Content data={content} onDemand={true} slides={cta} />
        </>
      )}
    </Layout>
  );
};

export default WebinarOnDemandPostPage;
